module.exports = __webpack_public_path__ + "static/media/kids_02.fb1f0925.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kids/JPEG/kids_02.jpg
// module id = 5858
// module chunks = 0